export default {
  tip_client_label: 'Tip client',
  tip_client_casnic: 'casnic',
  tip_client_non_casnic: 'noncasnic',
  tip_client_rule_required: 'Tipul de client este obligatoriu.',
  tip_client_rule_in: 'Tipul de client este invalid.',

  modalitate_racordare_label: 'Modalitate de racordare',
  modalitate_racordare_sistem_distributie: 'Sistem de distributie',
  modalitate_racordare_sistem_transport: 'Sistem de transport',
  modalitate_racordare_amonte: 'Conducta de alimentare din amonte',
  modalitate_racordare_rule_required: 'Modalitatea de racordare este obligatorie.',
  modalitate_racordare_rule_in: 'Modalitatea de racordare este invalida.',

  transee_de_consum_label: 'Categoria de consum anual',
  transee_de_consum_no_data: 'Intai alege modalitatea de racordare',
  transee_de_consum_a1: 'mai mic sau egal cu 28.000 MWh / an',
  transee_de_consum_a2: 'de peste 28.000 MWh / an',
  transee_de_consum_b1: 'mai mic sau egal cu 280 MWh / an',
  transee_de_consum_b2: 'intre 281 MWh si  2800 MWh / an',
  transee_de_consum_b3: 'intre 2801 MWh si  28000 MWh / an',
  transee_de_consum_b4: 'intre 28001 MWh si  280 000 MWh / an',
  transee_de_consum_b5: 'de peste 280 000 MWh / an',
  transee_de_consum_rule_required: 'Consumul anual este obligatoriu.',
  transee_de_consum_rule_in: 'Modalitatea de racordare este invalid.',

  judet_label: 'Judet',
  judet_rule_required: 'Judetul este obligatoriu.',

  localitate_label: 'Localitate',
  localitate_no_data_label: 'Intai alege judetul',
  localitate_rule_required: 'Localitatea este obligatorie.',

  tip_pret_unitar_label: 'Tip pret unitar',
  tip_pret_unitar_cu_reglementate: 'Cu servicii reglementate incluse',
  tip_pret_unitar_fara_reglementate: 'Fara servicii reglementate incluse',
  tip_pret_unitar_rule_required: 'Tipul pretului unitar este obligatoriu.',
  tip_pret_unitar_rule_in: 'Tipul pretului unitar este invalid.',

  mai_multe_label: 'Adauga mai multe criterii de selectie',

  termen_plata_label: 'Termen de plata',
  termen_de_plata_oricare: 'Oricare',
  termen_de_plata_pana_15: 'mai mic sau egal cu 15 zile',
  termen_de_plata_15_30: 'intre 16 si 29 zile',
  termen_de_plata_peste_30: 'mai mare sau egal cu 30 zile',
  termen_plata_rule_in: 'Termenul de plata este invalid.',

  mod_transmitere_factura_oricare: 'Oricare',
  mod_transmitere_factura_tiparita: 'factura tiparita',
  mod_transmitere_factura_electronica: 'factura electronica',
  mod_transmitere_factura_rule_in: 'Modalitatea de racordare este invalid.',

  durata_contractului_label: 'Durata contractului',
  durata_contractului_oricare: 'Oricare',
  durata_contractului_nedeterminata: 'nedeterminata',
  durata_contractului_6: 'mai mica de 12 luni',
  durata_contractului_12: '12 luni',
  durata_contractului_24: 'intre 13 si 24 de luni',
  durata_contractului_36: 'mai mare de 24 luni',
  durata_contractului_rule_in: 'Durata contractului este invalida.',

  garantii_label: 'Garantii',
  garantii_oricare: 'Oricare',
  garantii_cu_garantii: 'cu garantii',
  garantii_fara_garantii: 'fara garantii',
  garantii_rule_in: 'Garantia este invalida.',

  si_mai_multe_label: 'Date pentru comparare',

  unitate_de_consum_label: 'Unitate de consum',
  unitate_de_consum_hint: 'Schimba intre KWh si MWh',

  consum_mwh_label: 'Consum anual estimat',
  consum_mwh_rule_required_with: 'Consumul anual estimat este obligatoriu daca pretul contractului actual este specificat.',
  consum_mwh_rule_number: 'Consumul anual estimat sa fie un numar pozitiv.',

  pret_furnizare_mwh_label: 'Pretul actual',
  pret_furnizare_mwh_hint: 'de furnizare din contractul actual fara TVA si acciza',
  pret_furnizare_mwh_rule_required_with: 'Pretul contractului actual este obligatoriu daca consumul anual estimat este specificat.',
  pret_furnizare_mwh_rule_number: 'Pretul contractului actual sa fie un numar pozitiv.',

  compara_preturi_label: 'Compara preturi',

  pret_furnizare_label: 'Pret de furnizare',
  valabilitate_label: 'Valabilitate',
  cost_anual_actual_label: 'Cost anual actual',
  cost_anual_previzionat_label: 'Cost anual previzionat',
  procent_label: 'Procent',

  economisiti: 'Economisiti {0} lei anual',
  platiti: 'Platiti mai mult cu {0} lei anual',

  pret_gaze_naturale_label: 'Pret gaze naturale',
  tarif_transport_label: 'Tarif de transport',
  tarif_distributie_label: 'Tarif de distributie',
  // termen_plata_label: 'Termen plata', // duplicate above
  mod_transmitere_factura_label: 'Modul de transmitere factura',
  // durata_contractului_label: 'Durata contractului', // duplicate above,
  website_label: 'Website',
  oferta_label: 'Oferta',

  data_start_aplicare_label: 'Data de la care se aplica oferta',
  data_start_aplicare_rule_required: 'Data de la care se aplica oferta este obligatoriu.',

  tip_oferta_label: 'Tip oferta',
  tip_oferta_oricare: 'Oricare',
  tip_oferta_simpla: 'Oferte simpla',
  tip_oferta_la_pachet: 'Oferta la pachet cu o oferta de Energie Electrica',
  tip_oferta_rule_required: 'Tipul ofertei este obligatoriu.',
  tip_oferta_rule_in: 'Tipul ofertei este invalid.',

  tip_pret_oferta_label: 'Tipul pretului gazelor naturale din oferta',
  tip_pret_oferta_oricare: 'Oricare',
  tip_pret_oferta_fix: 'Pret fix',
  tip_pret_oferta_variabil: 'Pret variabil',
  tip_pret_oferta_mixt: 'Pret mixt',
  tip_pret_oferta_variabil_spot: 'Pret variabil bazat pe preturi SPOT',
  tip_pret_oferta_variabil_angro: 'Pret variabil bazat pe preturi ANGRO',
  tip_pret_oferta_maxim: 'Pret maxim',
  tip_pret_oferta_index_variabil: 'Pret variabil bazat pe un Index variabil',
  tip_pret_oferta_required: 'Tipul pretului gazelor naturale din oferta este obligatoriu.',
  tip_pret_oferta_rule_in: 'Tipul pretului gazelor naturale din oferta invalid.',

  suplimentar_componenta_fixa_label: 'Componenta fixa (abonamentul) lei/zi',
  suplimentar_componenta_fixa_oricare: 'Oricare',
  suplimentar_componenta_fixa_da: 'da',
  suplimentar_componenta_fixa_nu: 'nu',
  suplimentar_componenta_fixa_required: 'Componenta fixa (abonamentul) lei/zi este obligatoriu.',
  suplimentar_componenta_fixa_rule_in: 'Componenta fixa (abonamentul) lei/zi este invalid.',

  frecventa_emitere_factura_label: 'Frecventa emitere factura',
  frecventa_emitere_factura_oricare: 'Oricare',
  frecventa_emitere_factura_lunara: 'lunar',
  frecventa_emitere_factura_2_luni: 'la 2 luni',
  frecventa_emitere_factura_3_luni: 'la 3 luni',
  frecventa_emitere_factura_required: 'Frecventa emitere factura este obligatoriu.',
  frecventa_emitere_factura_rule_in: 'Frecventa emitere factura este invalid.',

  componenta_fixa_label: 'Introduceți componenta fixă (abonament) din factura actuală, dacă există (lei/zi, fără TVA)',
  componenta_fixa_hint: 'Vă recomandam să completați si acest câmp pentru a obține informaţii comparative despre preţ și costuri in tabelul de rezultate',
  componenta_fixa_rule_number: 'Componenta fixă sa fie un numar pozitiv.',

  modul_transmitere_factura_label: 'Modul de transmitere al facturii',

  documente_client_nou_label: 'Client nou (construcţie nouă, schimbare proprietar,etc.)',
  documente_client_furnizor_existent: 'Schimbare condiţii contract (schimbare tip contract, ofertă noua, prelungire contract, etc)',
  documente_client_furnizor_nou: 'Schimbare furnizor',

  introduceti_pretul_actual: '(introduceți prețul actual)',
  introduceti_consumul_estimat: '(introduceți consumul estimat)',
  introduceti_datele: '(introduceți datele)'
}
